import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash-es';
import { LeadFormDrawer } from 'site-modules/shared/components/lead-form/lead-form-drawer/lead-form-drawer';
import { EventToolbox } from 'client/utils/event-toolbox';
import { INVENTORY_PAGE_CUSTOM_EVENTS } from 'site-modules/shared/constants/inventory/page-events';
import { LEAD_FORM_NAMES } from 'site-modules/shared/constants/lead-form/lead-form-names';
import { UnifiedLeadFormWrapper } from 'site-modules/shared/components/lead-form/unified-lead-form/unified-lead-form-wrapper';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PageModel } from 'client/data/models/page';
import { InventoryEntities } from 'client/data/models/inventory';
import { DealerInfoEntities } from 'client/data/models/dealer-info';
import { getQuery } from 'client/utils/location';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { LEAD_FORMS_CREATIVE_ID } from 'site-modules/shared/components/lead-form/unified-lead-form/constants/creative-ids';
import { getLeadFormCreativeId } from 'site-modules/shared/components/lead-form/utils/lead-form-creative-id';
import { CarBuyingModel } from 'client/data/models/car-buying';
import { DEFAULT_PHOTO } from 'site-modules/shared/utils/inventory-image-utils';
import { CALCULATOR_TYPE_LEASE, CALCULATOR_TYPE_LOAN } from 'site-modules/shared/constants/calculator/calculator';
import { getReceiptId, getTradeInDetails } from 'site-modules/shared/utils/car-buying/calculator-util';
import { mapLoanDataToRetailModel } from 'site-modules/shared/utils/car-buying/map-to-retail-model';
import { DIGITAL_RETAIL_LEAD_STEP_PARAM } from 'site-modules/shared/constants/car-buying/pre-qualify-step-constants';
import { isLeaseEnabled } from 'site-modules/shared/utils/inventory-utils/is-lease-enabled';
import { DrawerV2 } from 'site-modules/shared/components/drawer/drawer-v2';
import { WhiteBackButton } from 'site-modules/shared/components/lead-form/lead-form-drawer/close-buttons/white-back-button/white-back-button';

export class VDPLeadFormWrapperUI extends Component {
  static propTypes = {
    formName: PropTypes.string,
    vinData: InventoryEntities.InventoryVin,
    dealerInfo: DealerInfoEntities.DealerInfo,
    zipCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isMobile: PropTypes.bool,
    pageName: PropTypes.string.isRequired,
    featureFlags: PropTypes.shape({}),
    pathname: PropTypes.string,
    search: PropTypes.string,
    pageNameLegacy: PropTypes.string,
    tcpaParentDealershipName: PropTypes.string,
    isDRLeadFormSubmitAvailable: PropTypes.bool,
    isDigitalRetailAvailable: PropTypes.bool,
    visitorId: PropTypes.string,
    photoUrl: PropTypes.string,
    calculatorPayments: PropTypes.shape({}),
    isPurchase: PropTypes.bool,
    location: PropTypes.shape({}),
    customConfig: PropTypes.shape({}),
  };

  static defaultProps = {
    formName: LEAD_FORM_NAMES.UCI,
    vinData: {},
    dealerInfo: {},
    zipCode: null,
    isMobile: false,
    featureFlags: {},
    pathname: '',
    search: '',
    pageNameLegacy: '',
    tcpaParentDealershipName: null,
    isDigitalRetailAvailable: false,
    isDRLeadFormSubmitAvailable: false,
    visitorId: '',
    photoUrl: DEFAULT_PHOTO,
    calculatorPayments: {},
    isPurchase: false,
    location: {},
    customConfig: {},
  };

  state = {
    isOpen: false,
  };

  componentDidMount() {
    EventToolbox.on(INVENTORY_PAGE_CUSTOM_EVENTS.OPEN_LEAD_FORM, this.toggleLeadFormDrawer);
  }

  /**
   * Toggles lead form drawer.
   */
  toggleLeadFormDrawer = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    const { isOpen } = this.state;
    const {
      vinData,
      dealerInfo,
      formName,
      zipCode,
      pageName,
      isMobile,
      pathname,
      featureFlags,
      search,
      pageNameLegacy,
      tcpaParentDealershipName,
      isDRLeadFormSubmitAvailable,
      isDigitalRetailAvailable,
      visitorId,
      photoUrl,
      calculatorPayments,
      isPurchase,
      location,
      customConfig,
    } = this.props;

    if (!vinData) return null;

    const vin = get(vinData, 'vin');
    const styleInfo = get(vinData, 'vehicleInfo.styleInfo');

    const make = get(styleInfo, 'make', '');
    const model = get(styleInfo, 'model', '');
    const year = get(styleInfo, 'year', '');
    const subModels = get(styleInfo, 'subModels');
    const trim = get(styleInfo, 'trim', '');
    const styleId = get(styleInfo, 'styleId');

    const submodel = get(subModels, '[0].name', '');
    const submodelIdentifier = get(subModels, '[0].identifier', '');
    const priceStrikethrough = get(vinData, 'computedDisplayInfo.priceStrikethrough', false);
    const isNewVin = isNew(get(vinData, 'type'));

    const openedForm = isPurchase ? CALCULATOR_TYPE_LOAN : CALCULATOR_TYPE_LEASE;
    const paymentData = calculatorPayments[openedForm];
    const offer = get(paymentData, 'calculatedOffer', {});
    const mappedLoanOffer =
      offer && !isEmpty(offer) && isPurchase
        ? { ...mapLoanDataToRetailModel(offer), apr: get(paymentData, 'apr', 0) }
        : {};
    const dealOffer = isPurchase ? mappedLoanOffer : offer;

    const params = {
      vin,
      make,
      model,
      year,
      styleId,
      submodel,
      submodelIdentifier,
      trim,
      zipCode,
      pageName,
      priceStrikethrough,
      isNewVin,
      pageNameLegacy,
      isLease: isLeaseEnabled(location),
    };
    const additionalParams = {
      isDRLeadFormSubmitAvailable,
      visitorId,
      deals: [
        {
          inventory: vinData,
          photo: photoUrl,
          dealOffer: {
            ...dealOffer,
            creditScore: get(paymentData, 'creditScore'),
            isPurchase,
          },
          calculatedData: {
            tradeInDetails: getTradeInDetails({
              selections: get(paymentData, 'storedSelections', {}),
              limitCriteria: get(dealOffer, 'limitCriteria', {}),
              appliedTradeIn: get(dealOffer, 'tradeIn'),
              pubState: vinData.type,
            }),
          },
        },
      ],
      queryParams: {
        step: DIGITAL_RETAIL_LEAD_STEP_PARAM,
        skipSurvey: true,
        suppressLead: false,
        skipLead: false,
        useDigitalRetail: isDigitalRetailAvailable,
        shopperCampaign: getReceiptId(isPurchase, !isNewVin),
      },
    };
    const options = {
      featureFlags,
      pathname,
      dealerInfo,
      isMobile,
      skipDRBtn: get(featureFlags, 'skipCBPButton', false),
      tcpaParentDealershipName,
    };

    const query = getQuery({ search });
    const radiusQuery = get(query, 'radius');
    const radius = radiusQuery ? Number(radiusQuery) : null;
    // this check prevents radius override if it is null
    if (radius) {
      params.radius = radius;
      options.radius = radius;
    }

    const dataTrackingParent = getLeadFormCreativeId({
      isNewVin,
      pageNameLegacy,
      formName: LEAD_FORMS_CREATIVE_ID.SINGLE_BASE_VDP_FORM,
    });

    const leadFormDrawerConfig =
      formName === LEAD_FORM_NAMES.SIMPLE_INVENTORY_LEAD_FORM
        ? {
            drawerContentClassName: 'bg-cool-gray-90',
            closeBtnComponent: WhiteBackButton,
            containerClassName: 'pos-st p-0',
            isLFComponentContainerFluid: true,
            drawerContentWrapperClassName: 'px-1 px-md-2_5',
            className: 'vdp-simple-inventory-lead-form',
            drawerComponent: DrawerV2,
          }
        : {};

    return (
      <LeadFormDrawer
        url={''}
        component={UnifiedLeadFormWrapper}
        componentData={{
          formName,
          params: isDRLeadFormSubmitAvailable
            ? {
                ...params,
                ...additionalParams,
              }
            : params,
          options: { ...options, isOpen, customConfig },
        }}
        isOpen={isOpen}
        onDrawerToggle={this.toggleLeadFormDrawer}
        shouldRemoveOnClose={false}
        dataTrackingParent={dataTrackingParent}
        {...leadFormDrawerConfig}
      />
    );
  }
}

const mapStateToProps = state => ({
  isMobile: get(state, 'mobile'),
  zipCode: get(state, 'visitor.location.zipCode'),
  pageName: get(state, 'pageContext.page.name'),
  featureFlags: get(state, 'featureFlags'),
  pageNameLegacy: get(state, 'pageContext.legacy.pageName') || get(state, 'pageContext.page.name'),
  visitorId: get(state, 'visitor.id'),
  location: get(state, 'pageContext.location'),
});

const stateToPropsConfig = {
  pathname: bindToPath('location.pathname', PageModel),
  search: bindToPath('location.search', PageModel),
  photoUrl: bindToPath(({ vinData }) => vinData && vinData.vin && `vins["${vinData.vin}"].photoUrl`, CarBuyingModel),
};

export const VdpLeadFormWrapper = connect(mapStateToProps)(connectToModel(VDPLeadFormWrapperUI, stateToPropsConfig));
